// extracted by mini-css-extract-plugin
export default {"form":"RelatorioFaturamento_form__Yo+HB","areaBtn":"RelatorioFaturamento_areaBtn__X--r-","btn":"RelatorioFaturamento_btn__5fFFQ","btn2":"RelatorioFaturamento_btn2__BIudJ"};